import { Reminder, TranslateFunction } from '@griply/types';

import { getReminderLabel } from './get-reminder-label';

// Expects the task's effective reminders — a legacy `reminderTime` must be resolved before it gets here.
export const getRemindersSummaryLabel = (
  reminders: Reminder[] | null | undefined,
  t: TranslateFunction,
  formatOffset: (offset: number) => string | null,
): string | undefined => {
  const [first, ...others] = reminders ?? [];

  if (!first) {
    return undefined;
  }

  const label =
    getReminderLabel(first, t) ?? formatOffset(first.offset) ?? undefined;

  if (!label) {
    return undefined;
  }

  return others.length ? `${label} +${others.length}` : label;
};
